import { clearEpixProductDetails, clearMultiEpixSortiment, editMultiEpixFilter, loadMoreMultiEpixSortiment, prepareQueryOptions, updateChainProducts } from "../actions/multiEpixSortiment";
import { exportCsv, loadChains } from "../actions/multiChainSortiment";
import { setDropDown, setModal } from "../../common/actions/modal";

import MultiEpixPage from "../components/MultiEpixPage.jsx";
import { connect } from "react-redux";
import { createBoundFunction } from "../../common/util/reselect.js";
import { createFlowControl } from "../../common/util/flowControl";
import { createLocalization } from "../../common/util/localization.jsx";
import { scssVariables } from "../../common/util/config.jsx";

const mapStateToProps = () => {
    const flowControl = createFlowControl();
    const flowControlCounter = createFlowControl();

    return (state) => ({
        chains: state.multiChainSortiment.chains,
        deviceType: state.view.deviceType,
        flowControl: flowControl,
        flowControlCounter: flowControlCounter,
        height: state.view.innerHeight - parseInt(scssVariables.menuHeight),
        localization: createLocalization(state),
        multiEpixSortiment: state.multiEpixSortiment,
        width: state.view.innerWidth,
    });
};

const mapDispatchToProps = {
    clearEpixProductDetails,
    clearMultiEpixSortiment,
    editMultiEpixFilter,
    loadChains,
    loadMoreMultiEpixSortiment,
    prepareQueryOptions,
    setModal,
    setDropDown,
    updateChainProducts,
    exportCsv,
};

const myLoadMoreMultiEpixSortiment = createBoundFunction();
const myEditMultiEpixFilter = createBoundFunction();

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    loadMoreMultiEpixSortiment: myLoadMoreMultiEpixSortiment((noOfProducts) => dispatchProps.loadMoreMultiEpixSortiment(stateProps.multiEpixSortiment, stateProps.productImage, noOfProducts)),
    editMultiEpixFilter: myEditMultiEpixFilter((change) => dispatchProps.editMultiEpixFilter(change,
        myLoadMoreMultiEpixSortiment((noOfProducts) => dispatchProps.loadMoreMultiEpixSortiment(stateProps.multiEpixSortiment, stateProps.productImage, noOfProducts))
    )),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(MultiEpixPage);
